export class TimeBetweenSwipesCalculator {
    static START_TIME_SWIPE_MARK = 'start_time_swipe'
    static END_TIME_SWIPE_MARK = 'end_time_swipe'
    static TIME_TO_SWIPE_MEASURE = 'time_to_swipe'

    static resetStopTime() {
        performance
            .clearMeasures(this.TIME_TO_SWIPE_MEASURE)
    }

    static reset() {
        performance
            .clearMarks(this.START_TIME_SWIPE_MARK)
        performance
            .clearMarks(this.END_TIME_SWIPE_MARK)
        this.resetStopTime()   
    }
    
    static startTimer() {
        performance
            .mark(this.START_TIME_SWIPE_MARK)
    }

    static toggleTimer() {
        let swipeTime = 0
        const startMarks =
            performance
                .getEntriesByName(this.START_TIME_SWIPE_MARK, 'mark')
        if (startMarks.length) {
            this.resetStopTime()
            performance
                .mark(this.END_TIME_SWIPE_MARK)
            performance
                .measure(
                    this.TIME_TO_SWIPE_MEASURE,
                    this.START_TIME_SWIPE_MARK,
                    this.END_TIME_SWIPE_MARK,
                )
            const entries =
                performance
                    .getEntriesByName(this.TIME_TO_SWIPE_MEASURE)
            if (entries.length) {
                // has entries: non null operator valid 
                swipeTime =
                    Math.round(
                        entries.at(0)!.duration
                    )
                this.reset()
                this.startTimer()
            }
        } else {
            TimeBetweenSwipesCalculator.startTimer()
        }
        return swipeTime
    }
}
